import { loadDaxRates, loadConfig } from "./utils";
import { currencyFormatter } from "./formatters";

async function getAverageRate(){
  const DaxRatesRaw = await loadDaxRates();
  let averageRate =(1 +getMean(DaxRatesRaw.map(x=>parseFloat(x[1]))))**12 - 1;
  return averageRate;
}

async function getSimulatedRates(periods, simulationRuns) {

    const DaxRatesRaw = await loadDaxRates();

    let resultRates = [];
  
    for (var t = 1; t <= simulationRuns; t++) {
      let simulatedRates = [];
      periods.forEach((period, index) => {
        let tempArrayPeriod = [];
        for (var j = 1; j <= 12 * period.length; j++) {
          tempArrayPeriod.push(
            parseFloat(
              DaxRatesRaw[Math.floor(Math.random() * DaxRatesRaw.length)][1]
            )
          );
        }
        simulatedRates.push(tempArrayPeriod);
      });
  
      let simulatedPeriodRates = simulatedRates.map((aMonthlyRates, index) => {
        let a =
          aMonthlyRates.reduce((previousValue, currentValue) => {
            return previousValue * (1 + currentValue);
          }, 1) - 1;
  
        return a;
      });
  
      resultRates.push(simulatedPeriodRates);
    }
 

  
    return {resultRates: resultRates};
   
}

function getHistData(data,label){

    let histData = [];

    const q99 = getQuantile(data,0.99);
    const q01 = getQuantile(data,0.01);
    //const minSim = getQuantile(data,0.02);
    //const maxSim = data.reduce((a, b) => Math.max(a, b), -Infinity);
    const minSim = q01;//Math.min(...simResults);

    const step = (q99 - q01) / 20;
    let upperLimit = 0;
    let lowerLimit = 0;
    histData = new Array(20).fill(null).map((_, index) => {
        lowerLimit = minSim + (index) * step;
        upperLimit = minSim + (index + 1) * step;
        return {
            histId: label + ": " + currencyFormatter(Math.floor(lowerLimit / 10) * 10 + 1) + " - " + currencyFormatter(Math.floor(upperLimit / 10) * 10) ,
            histValue: (data.filter(x => lowerLimit <= x && x < upperLimit).length/data.length)
        }
    })

    histData.push( {
      histId: label + ": > " + currencyFormatter(Math.floor(q99 / 10) * 10) ,
      histValue: 0.01
  })
    histData.unshift( {
      histId: label + ": <= " + currencyFormatter(Math.floor(q01 / 10) * 10) ,
      histValue: 0.01
  })

    if (Math.floor(q01) === Math.floor(q99)){histData = [{histId: label + ":" + currencyFormatter(q01), histValue: 1}]}

    return histData;

}

function getQuantile(arr,q){

    if (arr.length === 0){ return undefined};

    const asc = (arr) => arr.sort((a, b) => a - b);

      const sorted = asc(arr);
      const pos = (sorted.length - 1) * q;
      const base = Math.floor(pos);
      const rest = pos - base;
      if (sorted[base + 1] !== undefined) {
        return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
      } else {
        return sorted[base];
      }
    }

function getStandardDeviation (array) {
  if (array.length === 0){ return undefined};
        const n = array.length
        const mean = array.reduce((a, b) => a + b) / n
        return Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n)
      }
   
function getMean (array) {
  if (array.length === 0){ return undefined};
    return array.reduce((a, b) => a + b) / array.length
}
export {getAverageRate, getSimulatedRates, getHistData, getQuantile, getStandardDeviation, getMean};